import moduleState from './_store/state';
import * as moduleGetters from './_store/getters';

export default {
  namespaced: true,
  state: moduleState,
  getters: moduleGetters,
};
